<div class="h-100">
  <div class="d-grid col-12 border-bottom p-2">
    <img class="mx-auto d-block" style="width: 150px;" src="/assets/images/logo-main.svg?v={{logoVersionNumber()}}"
      alt="Pet Wants - Logo">
  </div>
  <div class="d-grid col-12 text-center mt-4 px-3">
    <h2 class="fw-bold">Terms and Conditions/Privacy Policy</h2>
    <h2 class="fw-bold">Pet Wants</h2>
  </div>
  <div class="d-grid container col-12 terms-container-2 p-5 position-relative">
    <div class="w-100 h-100">
      <p>
        Welcome to Pet Wants Cincy! These terms and conditions outline the rules and regulations for the use of our website
        and the purchase of our products and services.
      </p>
      <p>
        By accessing this website, we assume you accept these terms and conditions. Do not continue to use Pet Wants Cincy's
        website if you do not agree to take all of the terms and conditions stated on this page.
      </p>
      <p>
        The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and any or
        all Agreements: &quot;Client&quot;, "You" and "Your" refers to you, the person accessing this website and accepting
        the Company's terms and conditions. &quot;The Company&quot;, "Ourselves", "We", "Our" and &quot;Us&quot;, refers to
        our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves, or either the Client or ourselves.
        All terms refer to the offer, acceptance, and consideration of payment necessary to undertake the process of our
        assistance to the Client in the most appropriate manner, whether by formal meetings of a fixed duration or any other
        means, for the express purpose of meeting the Client's needs in respect of provision of the Company's stated
        services/products, in accordance with and subject to, prevailing law of. Any use of the above terminology or other
        words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as
        referring to the same.
      </p>
      <p>
        <strong>Cookies</strong>
      </p>
      <p>
        We employ the use of cookies. By accessing Pet Wants Cincy's website, you agreed to use cookies in agreement with the
        Pet Wants Cincy's Privacy Policy.
      </p>
      <p>
        Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our
        website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our
        affiliate/advertising partners may also use cookies.
      </p>
      <p>
        <strong>License</strong>
      </p>
      <p>
        Unless otherwise stated, Pet Wants Cincy and/or its licensors own the intellectual property rights for all material on
        Pet Wants Cincy. All intellectual property rights are reserved. You may access this from Pet Wants Cincy for your own
        personal use subjected to restrictions set in these terms and conditions.
      </p>
      <p>
        You must not:
      </p>
      <ul>
        <li>Republish material from Pet Wants Cincy</li>
        <li>Sell, rent or sub-license material from Pet Wants Cincy</li>
        <li>Reproduce, duplicate or copy material from Pet Wants Cincy</li>
        <li>Redistribute content from Pet Wants Cincy</li>
      </ul>
      <p>
        This Agreement shall begin on the date hereof.
      </p>
      <p>
        <strong>Delivery Service Disclaimer</strong>
      </p>
      <p>
        Pet Wants Cincy is committed to providing reliable and efficient delivery services for our customers. However,
        it&#39;s important to note that our delivery service is subject to the following disclaimers:
      </p>
      <ol>
        <li>
          <p>
            <strong>Delivery Times:</strong>
            While we make every effort to deliver orders within the specified time frame, delivery times are estimates and not
            guaranteed. Factors such as weather conditions, traffic, and other unforeseen circumstances may impact delivery
            times.
          </p>
        </li>
        <li>
          <p>
            <strong>Delivery Area Limitations:</strong> Our delivery service is available within specific geographic areas.
            Customers are responsible for providing accurate delivery addresses within our service area. We reserve the right
            to refuse delivery to locations outside our designated service area.
          </p>
        </li>
        <li>
          <p>
            <strong>Product Condition Upon Delivery:</strong> We take utmost care to ensure that products are delivered in
            good condition. However, customers are advised to inspect their orders upon delivery. Any issues with the
            delivered products should be reported to our customer service team within a reasonable timeframe.
          </p>
        </li>
        <li>
          <p>
            <strong>Delivery Confirmation:</strong> Our delivery service does its best to ensure that orders are received by
            the intended recipient. However, we cannot be held liable for orders once they have been confirmed as delivered.
          </p>
        </li>
        <li>
          <p>
            <strong>Changes to Delivery Schedule:</strong> We reserve the right to modify delivery schedules due to
            circumstances beyond our control. In such cases, we will make every effort to notify affected customers in a
            timely manner.
          </p>
        </li>
        <li>
          <p>
            <strong>Liability Limitations:</strong> Pet Wants Cincy shall not be held liable for any direct, indirect,
            incidental, special, or consequential damages arising from the use of our delivery service, including but not
            limited to delays, non-delivery, or product damage during transit.
          </p>
        </li>
      </ol>
      <p>
        By utilizing our delivery service, you acknowledge and agree to the terms outlined in this disclaimer. If you have
        any questions or concerns regarding our delivery service, please contact our customer service team for further
        assistance.
      </p>
    </div>
  </div>
  <div class="d-grid col-12 text-center mt-4">
    <h2 class="fw-bold">Mobile Terms of Service</h2>
    <h2 class="fw-bold">Pet Wants</h2>
    <p>Last updated: March 5, 2026</p>
  </div>
  <div class="d-grid container col-12 terms-container-2 p-5 position-relative">
    <div class="w-100 h-100">
      <p>The Pet Wants mobile message service (the "Service") is operated by Pet Wants ("Pet Wants", "we", or "us"). Your use of the Service constitutes your agreement to these terms and conditions ("Mobile Terms"). We may modify or cancel the Service or any of its features without notice. To the extent permitted by applicable law, we may also modify these Mobile Terms at any time and your continued use of the Service following the effective date of any such changes shall constitute your acceptance of such changes.</p>

      <p>By consenting to Pet Wants's SMS/text messaging service, you agree to receive recurring SMS/text messages from and on behalf of Pet Wants through your wireless provider to the mobile number you provided, even if your mobile number is registered on any state or federal Do Not Call list. Text messages may be sent using an automatic telephone dialing system or other technology. Promotional messages may include promotions, specials, and other marketing offers (e.g., cart reminders).</p>

      <p>You understand that you do not have to sign up for this program in order to make any purchases, and your consent is not a condition of any purchase with Pet Wants. Your participation in this program is completely voluntary.</p>

      <p>We do not charge for the Service, but you are responsible for all charges and fees associated with text messaging imposed by your wireless provider. Message frequency varies. Message and data rates may apply. Check your mobile plan and contact your wireless provider for details. You are solely responsible for all charges related to SMS/text messages, including charges from your wireless provider.</p>

      <p>You may opt-out of the Service at any time. Text the single keyword command STOP to +18888639406 or click the unsubscribe link (where available) in any text message to cancel. You'll receive a one-time opt-out confirmation text message. No further messages will be sent to your mobile device, unless initiated by you. If you have subscribed to other Pet Wants mobile message programs and wish to cancel, except where applicable law requires otherwise, you will need to opt out separately from those programs by following the instructions provided in their respective mobile terms.</p>

      <p>For Service support or assistance, text HELP to +18888639406 or email delivery&#64;petwantscincy.com.</p>

      <p>We may change any short code or telephone number we use to operate the Service at any time and will notify you of these changes. You acknowledge that any messages, including any STOP or HELP requests, you send to a short code or telephone number we have changed may not be received and we will not be responsible for honoring requests made in such messages.</p>

      <p>The wireless carriers supported by the Service are not liable for delayed or undelivered messages. You agree to provide us with a valid mobile number. If you get a new mobile number, you will need to sign up for the program with your new number.</p>

      <p>To the extent permitted by applicable law, you agree that we will not be liable for failed, delayed, or misdirected delivery of any information sent through the Service, any errors in such information, and/or any action you may or may not take in reliance on the information or Service.</p>
    </div>
  </div>
</div>